<template>
  <div id="recording-tab-caravanists">
    <vx-card class="mb-base" id="info-account-area">
      <!-- Profile -->
      <div class="vx-row w-full">
        <div id="data-cardlist-list" class="w-full">
          <div class="no-records" v-if="caravanists.length<1">
            <p>Não há dados disponíveis</p>
          </div>

          <div id="recordings-caravanists-list">
            <!-- <router-link tor="`/gravacoes/${record.id}`" class="cardlist-link"> -->
            <vs-card class="cardlist-data-recordings" :key="indextr" v-for="(record, indextr) in caravanists">
              <div class="cardlist-row">
                <div class="cardlist-item">
                  <span class="item-title">{{ record.name }}</span>
                </div>
                <div v-if="record.email" class="cardlist-item">
                  <span class="item-title">Email: </span>
                  <span class="item-text">{{ record.email }}</span>
                </div>
                <div class="cardlist-item">
                  <span class="item-title">Celular: </span>
                  <span class="item-text">{{ record.mobile | formatCelphone }}</span>
                </div>
                <div class="cardlist-item">
                  <span class="item-title">Vagas: </span>
                  <span class="item-text">{{ record.vacancies }}</span>
                </div>
              </div>
            </vs-card>
            <!-- </router-link> -->
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    data: {
      type: Array,
      required: false
    }
  },
  data() {
    return {}
  },
  computed: {
    caravanists() {
      return this.data || []
    }
  },
  methods: {},
  filters: {
    formatCelphone: value => {
      if (!value) return ''
      return value.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    },
  },
  mounted() {
    this.addNewDataSidebar = false
  }
}
</script>

<style lang="scss">
#recording-tab-caravanists {
  .vx-card__body {
    padding: 0;
    .con-vs-card {
      margin-bottom: 0;
      +.con-vs-card{
        margin-top: 10px;
      }
      .vs-card--content {
        margin-bottom: 0;
      }
    }
  }
}
.rounded-letter,
img.rounded {
  width: 77px;
  height: 77px;
}
img.rounded {
  height: auto;
  margin: 0 1em 0 0;
}
.rounded-letter {
  padding: 21px 0;
  margin: 0 21px 0 0;
  display: block;
  text-align: center;
  font-size: 2.5em;
  border-radius: 100%;
  line-height: 100%;
  background-color: #ccc;
}
.recording-name {
  max-width: 15rem;
}
.content-text p {
  word-break: break-all;
  line-height: 1.3em;
}
#data-cardlist-list > div {
  margin: 1px;
}
@media screen and (min-width: 540px) {
  #recording-tab-caravanists {
    .vs-card--content {
      width: 100%;
    }
    .vx-card__body {
      padding: 0;
      .con-vs-card {
        .cardlist-row {
          width: 100%;
          display: flex;
          .cardlist-item {
            flex-grow: 1;
            flex-basis: 0;
          }
        }
      }
    }
  }
}
</style>
